import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import RouteHistory from "go-core/utils/routeHistory";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { TransferApi } from "../../../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../../../services/Api/api";
import TransferForm from "../../components/TransferForm/TransferForm";

interface MatchParams {
	transferId: string;
}

const OrganizationTransferEditPage = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const { addFlash } = useFlash();
	const organization = useSelector(selectOrganization);
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>(undefined);
	const [transfer, setTransfer] = useState<TransferApi | undefined>(undefined);
	const { transferId } = useParams<MatchParams>();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		onFetchTransfer();
		onFetchResources();
	}, []);

	const goBack = () => RouteHistory.goBack(history, `/${organization.id}/documents/transfers`);

	const onFetchResources = async () => {
		try {
			const params = {
				resource_name: "TRANSFER_ORDER",
				custom_field_resource_type: "TRANSFER_ORDER",
				custom_field_permission_scope: "WRITE",
				include: "constraints",
			};
			const res = await api.organization().getResourceTypes(params);
			setCustomFieldsConfig(res.custom_fields);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const onFetchTransfer = async () => {
		try {
			const params = { include: "all" };
			const res = await api.organization().getTransfer(Number(transferId), params);
			setTransfer(res);
			handleChangeTabTitle(`${res.document_number} | ${t("modules.transfer.header.title")}`);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!customFieldsConfig || !transfer) return <LoadingContainer />;

	const title = `${t("modules.transfer.header.edit.title")} ${transfer.document_number}`;

	return (
		<>
			<Header title={title} back={goBack} />
			<TransferForm customFieldsConfig={customFieldsConfig} transfer={transfer} fetchTransfer={onFetchTransfer} />
		</>
	);
};

export default OrganizationTransferEditPage;
